import React from 'react';
import SingleServiceThree from '../../components/Service/SingleServiceThree';

import serviceBg from '../../assets/img/service/bg-2-1.jpg';

const Service = () => {
  return (
    <div
      className="it-service-3-area it-service-3-bg pt-120 pb-170"
      style={{ backgroundImage: `url(${serviceBg})` }}
    >
      <div className="container">
        <div className="row align-items-end">
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-55 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <div className="it-service-3-title-box">
              <span className="it-section-subtitle tertiary">What we do</span>
              <h3 className="it-section-title pb-20">
                Our services that <br />
                we Provide
              </h3>
              <p className="mb-0">
                related to health and wellness category <br /> includes medical
                treatments,
              </p>
            </div>
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-55 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleServiceThree
              name="Dr.Williams"
              icon="flaticon-refraction"
              title="Refractive Surgery"
              description="related to health and wellness category includes medical
                  treatments,"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-55 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleServiceThree
              name="Dr.Bishop"
              icon="flaticon-contact"
              title="Contact Lenses"
              description="related to health and wellness category includes medical
                  treatments,"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-55 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".8s"
          >
            <SingleServiceThree
              name="Dr.Tomczak"
              icon="flaticon-shared-vision"
              title="Refractive Surgery"
              description="related to health and wellness category includes medical
                  treatments,"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-55 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1s"
          >
            <SingleServiceThree
              name="Dr.Brownlee"
              icon="flaticon-eye"
              title="Refractive Surgery"
              description="related to health and wellness category includes medical
                  treatments,"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-55 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1.1s"
          >
            <SingleServiceThree
              name="Dr.Williams"
              icon="flaticon-laser-surgery"
              title="Refractive Surgery"
              description="related to health and wellness category includes medical
                  treatments,"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
